import { render, staticRenderFns } from "./input-carrinho.vue?vue&type=template&id=7f8bc820&scoped=true"
import script from "./input-carrinho.vue?vue&type=script&lang=js"
export * from "./input-carrinho.vue?vue&type=script&lang=js"
import style0 from "./input-carrinho.vue?vue&type=style&index=0&id=7f8bc820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8bc820",
  null
  
)

export default component.exports